import { Component, OnInit, OnDestroy } from '@angular/core';
import { SpinnerService } from './spinner.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'zsd-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit, OnDestroy {

  subscription: Subscription;
  showSpinner: boolean;
  showSpin: boolean;
  constructor(private spinnerService: SpinnerService) { }
  ngOnInit() {
    this.showSpinner = false;
    this.showSpin = false;
    this.subscription = this.spinnerService.spinnerSubject
      .subscribe((state: boolean) => {
        this.showSpinner = state;
      });
    this.subscription = this.spinnerService.smallSpinner
      .subscribe((state: boolean) => {
        this.showSpin = state;

      });
  }

  ngOnDestroy() { // This need to be change after upgrade
  //  if (this.subscription.unsubscribe()) {
      this.subscription.unsubscribe();
   // }
  }
}
